<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="m-l-14">
      <el-input
        size="small"
        v-model.trim="filters.smallClassName"
        placeholder="小班简称"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="query"></butn>
      <butn title="重置" @click="reset" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";

export default {
  components: { butn },
  data() {
    return {
      filters: {
        smallClassName: "",
      },
    };
  },
  methods: {
    query() {
      this.$emit("search", { ...this.filters });
    },
    reset() {
      this.filters = {
        smallClassName: "",
      };
      this.query();
    },
  },
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
  float: right;
}
</style>
